window.HS_SWATCH_DATA = window.HS_SWATCH_DATA || {};
window.HS_SWATCH_DATA["roller-semi-blackout"] = {
  "product_key": "roller-semi-blackout",
  "minimum_order_quantity": 5,
  "tier_guide": [
    {
      "tier": "Tier 1",
      "label": "Economy Collection"
    },
    {
      "tier": "Tier 2",
      "label": "Residential Collection"
    },
    {
      "tier": "Tier 3",
      "label": "Performance Collection"
    }
  ],
  "swatches": [
    {
      "id": "roller-semi-blackout-ME11-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME11",
      "fabric_code": "ME11-001",
      "web_name": "Pure Horizon",
      "name_key": "pure-horizon",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTExLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025841791195-ME11-001.jpg",
      "search_text": "ME11-001 Pure Horizon Performance Collection",
      "sort_order": 137,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME11-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME11",
      "fabric_code": "ME11-002",
      "web_name": "Warm Linen Mist",
      "name_key": "warm-linen-mist",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTExLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025841791195-ME11-002.jpg",
      "search_text": "ME11-002 Warm Linen Mist Performance Collection",
      "sort_order": 138,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME11-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME11",
      "fabric_code": "ME11-003",
      "web_name": "Soft Sandstone",
      "name_key": "soft-sandstone",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTExLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025841791195-ME11-003.jpg",
      "search_text": "ME11-003 Soft Sandstone Performance Collection",
      "sort_order": 139,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME11-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME11",
      "fabric_code": "ME11-004",
      "web_name": "Desert Weave",
      "name_key": "desert-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTExLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025841791195-ME11-004.jpg",
      "search_text": "ME11-004 Desert Weave Performance Collection",
      "sort_order": 140,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME11-005",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME11",
      "fabric_code": "ME11-005",
      "web_name": "Deep Urban Ash",
      "name_key": "deep-urban-ash",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTExLTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025841791195-ME11-005.jpg",
      "search_text": "ME11-005 Deep Urban Ash Performance Collection",
      "sort_order": 141,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME11-006",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME11",
      "fabric_code": "ME11-006",
      "web_name": "Midnight Loom",
      "name_key": "midnight-loom",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTExLTAwNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025841791195-ME11-006.jpg",
      "search_text": "ME11-006 Midnight Loom Performance Collection",
      "sort_order": 142,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME13-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME13",
      "fabric_code": "ME13-001",
      "web_name": "Ivory Veil",
      "name_key": "ivory-veil",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTEzLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025841791195-ME13-001.jpg",
      "search_text": "ME13-001 Ivory Veil Performance Collection",
      "sort_order": 143,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME13-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME13",
      "fabric_code": "ME13-002",
      "web_name": "Frosted Cloud",
      "name_key": "frosted-cloud",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTEzLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025841791195-ME13-002.jpg",
      "search_text": "ME13-002 Frosted Cloud Performance Collection",
      "sort_order": 144,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME13-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME13",
      "fabric_code": "ME13-003",
      "web_name": "Luna Weave",
      "name_key": "luna-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTEzLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025841791195-ME13-003.jpg",
      "search_text": "ME13-003 Luna Weave Performance Collection",
      "sort_order": 145,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME13-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME13",
      "fabric_code": "ME13-004",
      "web_name": "Porcelain Haze",
      "name_key": "porcelain-haze",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTEzLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025841791195-ME13-004.jpg",
      "search_text": "ME13-004 Porcelain Haze Performance Collection",
      "sort_order": 146,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME13-005",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME13",
      "fabric_code": "ME13-005",
      "web_name": "Chalk Serenity",
      "name_key": "chalk-serenity",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTEzLTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025841791195-ME13-005.jpg",
      "search_text": "ME13-005 Chalk Serenity Performance Collection",
      "sort_order": 147,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME5-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME5",
      "fabric_code": "ME5-001",
      "web_name": "Alabaster Veil",
      "name_key": "alabaster-veil",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTUtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025841791195-ME5-001.jpg",
      "search_text": "ME5-001 Alabaster Veil Performance Collection",
      "sort_order": 148,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME5-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME5",
      "fabric_code": "ME5-002",
      "web_name": "Dove Silk",
      "name_key": "dove-silk",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTUtMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025841791195-ME5-002.jpg",
      "search_text": "ME5-002 Dove Silk Performance Collection",
      "sort_order": 149,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME5-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME5",
      "fabric_code": "ME5-003",
      "web_name": "Champagne Loom",
      "name_key": "champagne-loom",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTUtMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025841791195-ME5-003.jpg",
      "search_text": "ME5-003 Champagne Loom Performance Collection",
      "sort_order": 150,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME5-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME5",
      "fabric_code": "ME5-004",
      "web_name": "Mushroom Heather",
      "name_key": "mushroom-heather",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTUtMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9025841791195-ME5-004.jpg",
      "search_text": "ME5-004 Mushroom Heather Performance Collection",
      "sort_order": 151,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME17-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME17",
      "fabric_code": "ME17-001",
      "web_name": "Polar Veil",
      "name_key": "polar-veil",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTE3LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025841791195-ME17-001.jpg",
      "search_text": "ME17-001 Polar Veil Performance Collection",
      "sort_order": 152,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME17-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME17",
      "fabric_code": "ME17-002",
      "web_name": "Strata Whisper",
      "name_key": "strata-whisper",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTE3LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025841791195-ME17-002.jpg",
      "search_text": "ME17-002 Strata Whisper Performance Collection",
      "sort_order": 153,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME17-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME17",
      "fabric_code": "ME17-003",
      "web_name": "Silken Horizon",
      "name_key": "silken-horizon",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTE3LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025841791195-ME17-003.jpg",
      "search_text": "ME17-003 Silken Horizon Performance Collection",
      "sort_order": 154,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME17-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME17",
      "fabric_code": "ME17-004",
      "web_name": "Luminous Weave",
      "name_key": "luminous-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTE3LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025841791195-ME17-004.jpg",
      "search_text": "ME17-004 Luminous Weave Performance Collection",
      "sort_order": 155,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME17-005",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 3",
      "collection_label": "Performance Collection",
      "source_product_label": "Light Filtering Roller Shades - Performance Collection",
      "fabric_series": "ME17",
      "fabric_code": "ME17-005",
      "web_name": "Aerial Current",
      "name_key": "aerial-current",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTAyNTg0MTc5MTE5NS1NRTE3LTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9025841791195-ME17-005.jpg",
      "search_text": "ME17-005 Aerial Current Performance Collection",
      "sort_order": 156,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME25-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME25",
      "fabric_code": "ME25-001",
      "web_name": "Gallery White",
      "name_key": "gallery-white",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTI1LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME25-001.jpg",
      "search_text": "ME25-001 Gallery White Residential Collection",
      "sort_order": 157,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME25-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME25",
      "fabric_code": "ME25-002",
      "web_name": "Oyster Dune",
      "name_key": "oyster-dune",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTI1LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME25-002.jpg",
      "search_text": "ME25-002 Oyster Dune Residential Collection",
      "sort_order": 158,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME25-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME25",
      "fabric_code": "ME25-003",
      "web_name": "Quayside Silver",
      "name_key": "quayside-silver",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTI1LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME25-003.jpg",
      "search_text": "ME25-003 Quayside Silver Residential Collection",
      "sort_order": 159,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME12-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME12",
      "fabric_code": "ME12-001",
      "web_name": "Pure Glacier",
      "name_key": "pure-glacier",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTEyLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME12-001.jpg",
      "search_text": "ME12-001 Pure Glacier Residential Collection",
      "sort_order": 160,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME12-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME12",
      "fabric_code": "ME12-002",
      "web_name": "Ivory Strand",
      "name_key": "ivory-strand",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTEyLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME12-002.jpg",
      "search_text": "ME12-002 Ivory Strand Residential Collection",
      "sort_order": 161,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME12-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME12",
      "fabric_code": "ME12-003",
      "web_name": "Linen Current",
      "name_key": "linen-current",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTEyLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME12-003.jpg",
      "search_text": "ME12-003 Linen Current Residential Collection",
      "sort_order": 162,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME12-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME12",
      "fabric_code": "ME12-004",
      "web_name": "Urban Flannel",
      "name_key": "urban-flannel",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTEyLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME12-004.jpg",
      "search_text": "ME12-004 Urban Flannel Residential Collection",
      "sort_order": 163,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME12-005",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME12",
      "fabric_code": "ME12-005",
      "web_name": "Steel Weave",
      "name_key": "steel-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTEyLTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME12-005.jpg",
      "search_text": "ME12-005 Steel Weave Residential Collection",
      "sort_order": 164,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME21-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME21",
      "fabric_code": "ME21-001",
      "web_name": "Pure Gallery",
      "name_key": "pure-gallery",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTIxLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME21-001.jpg",
      "search_text": "ME21-001 Pure Gallery Residential Collection",
      "sort_order": 165,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME21-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME21",
      "fabric_code": "ME21-002",
      "web_name": "Soft Limestone",
      "name_key": "soft-limestone",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTIxLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME21-002.jpg",
      "search_text": "ME21-002 Soft Limestone Residential Collection",
      "sort_order": 166,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME21-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME21",
      "fabric_code": "ME21-003",
      "web_name": "Urban Fog Dust",
      "name_key": "urban-fog-dust",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTIxLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME21-003.jpg",
      "search_text": "ME21-003 Urban Fog Dust Residential Collection",
      "sort_order": 167,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME21-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME21",
      "fabric_code": "ME21-004",
      "web_name": "Sage Concrete",
      "name_key": "sage-concrete",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTIxLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME21-004.jpg",
      "search_text": "ME21-004 Sage Concrete Residential Collection",
      "sort_order": 168,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME21-005",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME21",
      "fabric_code": "ME21-005",
      "web_name": "Midnight Slate Stone",
      "name_key": "midnight-slate-stone",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTIxLTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME21-005.jpg",
      "search_text": "ME21-005 Midnight Slate Stone Residential Collection",
      "sort_order": 169,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME23-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME23",
      "fabric_code": "ME23-001",
      "web_name": "Pearl Veil",
      "name_key": "pearl-veil",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTIzLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME23-001.jpg",
      "search_text": "ME23-001 Pearl Veil Residential Collection",
      "sort_order": 170,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME23-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME23",
      "fabric_code": "ME23-002",
      "web_name": "Soft Alabaster",
      "name_key": "soft-alabaster",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTIzLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME23-002.jpg",
      "search_text": "ME23-002 Soft Alabaster Residential Collection",
      "sort_order": 171,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME23-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME23",
      "fabric_code": "ME23-003",
      "web_name": "Silver Haze Silk",
      "name_key": "silver-haze-silk",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTIzLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME23-003.jpg",
      "search_text": "ME23-003 Silver Haze Silk Residential Collection",
      "sort_order": 172,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME23-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME23",
      "fabric_code": "ME23-004",
      "web_name": "Urban Mist",
      "name_key": "urban-mist",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTIzLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME23-004.jpg",
      "search_text": "ME23-004 Urban Mist Residential Collection",
      "sort_order": 173,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME23-005",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME23",
      "fabric_code": "ME23-005",
      "web_name": "Midnight Slate Silk",
      "name_key": "midnight-slate-silk",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTIzLTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME23-005.jpg",
      "search_text": "ME23-005 Midnight Slate Silk Residential Collection",
      "sort_order": 174,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME1-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME1",
      "fabric_code": "ME1-001",
      "web_name": "Pure Alabaster",
      "name_key": "pure-alabaster",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTEtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME1-001.jpg",
      "search_text": "ME1-001 Pure Alabaster Residential Collection",
      "sort_order": 175,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME1-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME1",
      "fabric_code": "ME1-002",
      "web_name": "Soft Ecru Veil",
      "name_key": "soft-ecru-veil",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTEtMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME1-002.jpg",
      "search_text": "ME1-002 Soft Ecru Veil Residential Collection",
      "sort_order": 176,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME1-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME1",
      "fabric_code": "ME1-003",
      "web_name": "Linen Whisper",
      "name_key": "linen-whisper",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTEtMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME1-003.jpg",
      "search_text": "ME1-003 Linen Whisper Residential Collection",
      "sort_order": 177,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME1-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME1",
      "fabric_code": "ME1-004",
      "web_name": "Silver Grain",
      "name_key": "silver-grain",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTEtMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME1-004.jpg",
      "search_text": "ME1-004 Silver Grain Residential Collection",
      "sort_order": 178,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME2-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME2",
      "fabric_code": "ME2-001",
      "web_name": "Alpine Sheer",
      "name_key": "alpine-sheer",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTItMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME2-001.jpg",
      "search_text": "ME2-001 Alpine Sheer Residential Collection",
      "sort_order": 179,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME2-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME2",
      "fabric_code": "ME2-002",
      "web_name": "Warm Ivory Weave",
      "name_key": "warm-ivory-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTItMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME2-002.jpg",
      "search_text": "ME2-002 Warm Ivory Weave Residential Collection",
      "sort_order": 180,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME2-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME2",
      "fabric_code": "ME2-003",
      "web_name": "Silver Strata",
      "name_key": "silver-strata",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTItMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME2-003.jpg",
      "search_text": "ME2-003 Silver Strata Residential Collection",
      "sort_order": 181,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME7-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME7",
      "fabric_code": "ME7-001",
      "web_name": "Ivory Veil Sheer",
      "name_key": "ivory-veil-sheer",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTctMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME7-001.jpg",
      "search_text": "ME7-001 Ivory Veil Sheer Residential Collection",
      "sort_order": 182,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME7-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME7",
      "fabric_code": "ME7-002",
      "web_name": "Linen Whisper Dust",
      "name_key": "linen-whisper-dust",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTctMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME7-002.jpg",
      "search_text": "ME7-002 Linen Whisper Dust Residential Collection",
      "sort_order": 183,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME7-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME7",
      "fabric_code": "ME7-003",
      "web_name": "Silver Weave",
      "name_key": "silver-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTctMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME7-003.jpg",
      "search_text": "ME7-003 Silver Weave Residential Collection",
      "sort_order": 184,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME9-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME9",
      "fabric_code": "ME9-001",
      "web_name": "Ivory Veil Dust",
      "name_key": "ivory-veil-dust",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTktMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME9-001.jpg",
      "search_text": "ME9-001 Ivory Veil Dust Residential Collection",
      "sort_order": 185,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME9-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME9",
      "fabric_code": "ME9-002",
      "web_name": "Warm Ecru",
      "name_key": "warm-ecru",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTktMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME9-002.jpg",
      "search_text": "ME9-002 Warm Ecru Residential Collection",
      "sort_order": 186,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME9-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME9",
      "fabric_code": "ME9-003",
      "web_name": "Natural Flax Stone",
      "name_key": "natural-flax-stone",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTktMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME9-003.jpg",
      "search_text": "ME9-003 Natural Flax Stone Residential Collection",
      "sort_order": 187,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME9-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME9",
      "fabric_code": "ME9-004",
      "web_name": "Stone Weave",
      "name_key": "stone-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTktMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME9-004.jpg",
      "search_text": "ME9-004 Stone Weave Residential Collection",
      "sort_order": 188,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME9-005",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME9",
      "fabric_code": "ME9-005",
      "web_name": "Midnight Grid",
      "name_key": "midnight-grid",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTktMDA1LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME9-005.jpg",
      "search_text": "ME9-005 Midnight Grid Residential Collection",
      "sort_order": 189,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME14-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME14",
      "fabric_code": "ME14-001",
      "web_name": "Ivory Veil Wind",
      "name_key": "ivory-veil-wind",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTE0LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME14-001.jpg",
      "search_text": "ME14-001 Ivory Veil Wind Residential Collection",
      "sort_order": 190,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME14-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME14",
      "fabric_code": "ME14-002",
      "web_name": "Soft Ecru",
      "name_key": "soft-ecru",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTE0LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME14-002.jpg",
      "search_text": "ME14-002 Soft Ecru Residential Collection",
      "sort_order": 191,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME14-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME14",
      "fabric_code": "ME14-003",
      "web_name": "Linen Glow",
      "name_key": "linen-glow",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTE0LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME14-003.jpg",
      "search_text": "ME14-003 Linen Glow Residential Collection",
      "sort_order": 192,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME14-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME14",
      "fabric_code": "ME14-004",
      "web_name": "Silver Haze Drift",
      "name_key": "silver-haze-drift",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTE0LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME14-004.jpg",
      "search_text": "ME14-004 Silver Haze Drift Residential Collection",
      "sort_order": 193,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME14-005",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME14",
      "fabric_code": "ME14-005",
      "web_name": "Urban Mist Breeze",
      "name_key": "urban-mist-breeze",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTE0LTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME14-005.jpg",
      "search_text": "ME14-005 Urban Mist Breeze Residential Collection",
      "sort_order": 194,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME14-006",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME14",
      "fabric_code": "ME14-006",
      "web_name": "Graphite Whisper",
      "name_key": "graphite-whisper",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTE0LTAwNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME14-006.jpg",
      "search_text": "ME14-006 Graphite Whisper Residential Collection",
      "sort_order": 195,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME3-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME3",
      "fabric_code": "ME3-001",
      "web_name": "Pearl Veil Breeze",
      "name_key": "pearl-veil-breeze",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTMtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME3-001.jpg",
      "search_text": "ME3-001 Pearl Veil Breeze Residential Collection",
      "sort_order": 196,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME3-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME3",
      "fabric_code": "ME3-002",
      "web_name": "Ivory Strata",
      "name_key": "ivory-strata",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTMtMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME3-002.jpg",
      "search_text": "ME3-002 Ivory Strata Residential Collection",
      "sort_order": 197,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME3-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME3",
      "fabric_code": "ME3-003",
      "web_name": "Silver Haze Sheer",
      "name_key": "silver-haze-sheer",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTMtMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME3-003.jpg",
      "search_text": "ME3-003 Silver Haze Sheer Residential Collection",
      "sort_order": 198,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME3-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME3",
      "fabric_code": "ME3-004",
      "web_name": "Soft Ash",
      "name_key": "soft-ash",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTMtMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME3-004.jpg",
      "search_text": "ME3-004 Soft Ash Residential Collection",
      "sort_order": 199,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME3-005",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME3",
      "fabric_code": "ME3-005",
      "web_name": "Urban Flint",
      "name_key": "urban-flint",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTMtMDA1LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME3-005.jpg",
      "search_text": "ME3-005 Urban Flint Residential Collection",
      "sort_order": 200,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME3-006",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME3",
      "fabric_code": "ME3-006",
      "web_name": "Smoked Linen",
      "name_key": "smoked-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTMtMDA2LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME3-006.jpg",
      "search_text": "ME3-006 Smoked Linen Residential Collection",
      "sort_order": 201,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME3-007",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME3",
      "fabric_code": "ME3-007",
      "web_name": "Charcoal Weave",
      "name_key": "charcoal-weave",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTMtMDA3LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME3-007.jpg",
      "search_text": "ME3-007 Charcoal Weave Residential Collection",
      "sort_order": 202,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME3-008",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME3",
      "fabric_code": "ME3-008",
      "web_name": "Midnight Slate Drift",
      "name_key": "midnight-slate-drift",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTMtMDA4LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME3-008.jpg",
      "search_text": "ME3-008 Midnight Slate Drift Residential Collection",
      "sort_order": 203,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME10-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME10",
      "fabric_code": "ME10-001",
      "web_name": "Porcelain Veil",
      "name_key": "porcelain-veil",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTEwLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME10-001.jpg",
      "search_text": "ME10-001 Porcelain Veil Residential Collection",
      "sort_order": 204,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME10-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME10",
      "fabric_code": "ME10-002",
      "web_name": "Ivory Whisper",
      "name_key": "ivory-whisper",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTEwLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME10-002.jpg",
      "search_text": "ME10-002 Ivory Whisper Residential Collection",
      "sort_order": 205,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME10-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME10",
      "fabric_code": "ME10-003",
      "web_name": "Lunar Silk",
      "name_key": "lunar-silk",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTEwLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME10-003.jpg",
      "search_text": "ME10-003 Lunar Silk Residential Collection",
      "sort_order": 206,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME10-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME10",
      "fabric_code": "ME10-004",
      "web_name": "Silver Ash",
      "name_key": "silver-ash",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTEwLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME10-004.jpg",
      "search_text": "ME10-004 Silver Ash Residential Collection",
      "sort_order": 207,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME10-005",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME10",
      "fabric_code": "ME10-005",
      "web_name": "Urban Pewter",
      "name_key": "urban-pewter",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTEwLTAwNS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME10-005.jpg",
      "search_text": "ME10-005 Urban Pewter Residential Collection",
      "sort_order": 208,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME10-006",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME10",
      "fabric_code": "ME10-006",
      "web_name": "Smoked Linen Mist",
      "name_key": "smoked-linen-mist",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTEwLTAwNi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME10-006.jpg",
      "search_text": "ME10-006 Smoked Linen Mist Residential Collection",
      "sort_order": 209,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME10-007",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME10",
      "fabric_code": "ME10-007",
      "web_name": "Midnight Graphite",
      "name_key": "midnight-graphite",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTEwLTAwNy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149698080987-ME10-007.jpg",
      "search_text": "ME10-007 Midnight Graphite Residential Collection",
      "sort_order": 210,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME4-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME4",
      "fabric_code": "ME4-001",
      "web_name": "Ivory Veil Mist",
      "name_key": "ivory-veil-mist",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTQtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME4-001.jpg",
      "search_text": "ME4-001 Ivory Veil Mist Residential Collection",
      "sort_order": 211,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME4-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME4",
      "fabric_code": "ME4-002",
      "web_name": "Silver Drift",
      "name_key": "silver-drift",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTQtMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME4-002.jpg",
      "search_text": "ME4-002 Silver Drift Residential Collection",
      "sort_order": 212,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME4-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME4",
      "fabric_code": "ME4-003",
      "web_name": "Graphite Linen",
      "name_key": "graphite-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTQtMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME4-003.jpg",
      "search_text": "ME4-003 Graphite Linen Residential Collection",
      "sort_order": 213,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME4-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME4",
      "fabric_code": "ME4-004",
      "web_name": "Espresso Weave Sheet",
      "name_key": "espresso-weave-sheet",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTQtMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME4-004.jpg",
      "search_text": "ME4-004 Espresso Weave Sheet Residential Collection",
      "sort_order": 214,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME4-005",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME4",
      "fabric_code": "ME4-005",
      "web_name": "Midnight Slate Smoke",
      "name_key": "midnight-slate-smoke",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTQtMDA1LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME4-005.jpg",
      "search_text": "ME4-005 Midnight Slate Smoke Residential Collection",
      "sort_order": 215,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME4-006",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME4",
      "fabric_code": "ME4-006",
      "web_name": "Obsidian Textura",
      "name_key": "obsidian-textura",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTQtMDA2LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME4-006.jpg",
      "search_text": "ME4-006 Obsidian Textura Residential Collection",
      "sort_order": 216,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME6-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME6",
      "fabric_code": "ME6-001",
      "web_name": "Ivory Veil Smoke",
      "name_key": "ivory-veil-smoke",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTYtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME6-001.jpg",
      "search_text": "ME6-001 Ivory Veil Smoke Residential Collection",
      "sort_order": 217,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME6-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME6",
      "fabric_code": "ME6-002",
      "web_name": "Linen Whisper Song",
      "name_key": "linen-whisper-song",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTYtMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME6-002.jpg",
      "search_text": "ME6-002 Linen Whisper Song Residential Collection",
      "sort_order": 218,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME6-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME6",
      "fabric_code": "ME6-003",
      "web_name": "Cloudstone",
      "name_key": "cloudstone",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTYtMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME6-003.jpg",
      "search_text": "ME6-003 Cloudstone Residential Collection",
      "sort_order": 219,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME6-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 2",
      "collection_label": "Residential Collection",
      "source_product_label": "Light Filtering Roller Shades - Residential Collection",
      "fabric_series": "ME6",
      "fabric_code": "ME6-004",
      "web_name": "Silver Mist Drift",
      "name_key": "silver-mist-drift",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTY5ODA4MDk4Ny1NRTYtMDA0LmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149698080987-ME6-004.jpg",
      "search_text": "ME6-004 Silver Mist Drift Residential Collection",
      "sort_order": 220,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME22-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME22",
      "fabric_code": "ME22-001",
      "web_name": "Ivory Veil Shower",
      "name_key": "ivory-veil-shower",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTIyLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME22-001.jpg",
      "search_text": "ME22-001 Ivory Veil Shower Economy Collection",
      "sort_order": 221,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME22-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME22",
      "fabric_code": "ME22-002",
      "web_name": "Pure Linen Mist",
      "name_key": "pure-linen-mist",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTIyLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME22-002.jpg",
      "search_text": "ME22-002 Pure Linen Mist Economy Collection",
      "sort_order": 222,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME22-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME22",
      "fabric_code": "ME22-003",
      "web_name": "Soft Alabaster Breeze",
      "name_key": "soft-alabaster-breeze",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTIyLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME22-003.jpg",
      "search_text": "ME22-003 Soft Alabaster Breeze Economy Collection",
      "sort_order": 223,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME18-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME18",
      "fabric_code": "ME18-001",
      "web_name": "Alabaster Drift",
      "name_key": "alabaster-drift",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTE4LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME18-001.jpg",
      "search_text": "ME18-001 Alabaster Drift Economy Collection",
      "sort_order": 224,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME18-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME18",
      "fabric_code": "ME18-002",
      "web_name": "Ivory Veil Gear",
      "name_key": "ivory-veil-gear",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTE4LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME18-002.jpg",
      "search_text": "ME18-002 Ivory Veil Gear Economy Collection",
      "sort_order": 225,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME18-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME18",
      "fabric_code": "ME18-003",
      "web_name": "Silver Haze Bar",
      "name_key": "silver-haze-bar",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTE4LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME18-003.jpg",
      "search_text": "ME18-003 Silver Haze Bar Economy Collection",
      "sort_order": 226,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME18-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME18",
      "fabric_code": "ME18-004",
      "web_name": "Graphite Linen Shot",
      "name_key": "graphite-linen-shot",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTE4LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME18-004.jpg",
      "search_text": "ME18-004 Graphite Linen Shot Economy Collection",
      "sort_order": 227,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME19-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME19",
      "fabric_code": "ME19-001",
      "web_name": "Porcelain Whisper",
      "name_key": "porcelain-whisper",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTE5LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME19-001.jpg",
      "search_text": "ME19-001 Porcelain Whisper Economy Collection",
      "sort_order": 228,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME20-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME20",
      "fabric_code": "ME20-001",
      "web_name": "Pearl Veil Dawn",
      "name_key": "pearl-veil-dawn",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTIwLTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME20-001.jpg",
      "search_text": "ME20-001 Pearl Veil Dawn Economy Collection",
      "sort_order": 229,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME20-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME20",
      "fabric_code": "ME20-002",
      "web_name": "Ivory Mist",
      "name_key": "ivory-mist",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTIwLTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME20-002.jpg",
      "search_text": "ME20-002 Ivory Mist Economy Collection",
      "sort_order": 230,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME20-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME20",
      "fabric_code": "ME20-003",
      "web_name": "Linen Whisper Sound",
      "name_key": "linen-whisper-sound",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTIwLTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME20-003.jpg",
      "search_text": "ME20-003 Linen Whisper Sound Economy Collection",
      "sort_order": 231,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME20-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME20",
      "fabric_code": "ME20-004",
      "web_name": "Silver Cloud",
      "name_key": "silver-cloud",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTIwLTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME20-004.jpg",
      "search_text": "ME20-004 Silver Cloud Economy Collection",
      "sort_order": 232,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME24-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME24",
      "fabric_code": "ME24-001",
      "web_name": "Chalk Whisper",
      "name_key": "chalk-whisper",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTI0LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME24-001.jpg",
      "search_text": "ME24-001 Chalk Whisper Economy Collection",
      "sort_order": 233,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME24-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME24",
      "fabric_code": "ME24-002",
      "web_name": "Silver Veil",
      "name_key": "silver-veil",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTI0LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME24-002.jpg",
      "search_text": "ME24-002 Silver Veil Economy Collection",
      "sort_order": 234,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME24-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME24",
      "fabric_code": "ME24-003",
      "web_name": "Soft Harbor",
      "name_key": "soft-harbor",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTI0LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME24-003.jpg",
      "search_text": "ME24-003 Soft Harbor Economy Collection",
      "sort_order": 235,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME27-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME27",
      "fabric_code": "ME27-001",
      "web_name": "Glacier Silk",
      "name_key": "glacier-silk",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTI3LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME27-001.jpg",
      "search_text": "ME27-001 Glacier Silk Economy Collection",
      "sort_order": 236,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME27-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME27",
      "fabric_code": "ME27-002",
      "web_name": "Warm Ecru Sound",
      "name_key": "warm-ecru-sound",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTI3LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME27-002.jpg",
      "search_text": "ME27-002 Warm Ecru Sound Economy Collection",
      "sort_order": 237,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME27-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME27",
      "fabric_code": "ME27-003",
      "web_name": "Urban Fog Dance",
      "name_key": "urban-fog-dance",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTI3LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME27-003.jpg",
      "search_text": "ME27-003 Urban Fog Dance Economy Collection",
      "sort_order": 238,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME27-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME27",
      "fabric_code": "ME27-004",
      "web_name": "Desert Taupe",
      "name_key": "desert-taupe",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTI3LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME27-004.jpg",
      "search_text": "ME27-004 Desert Taupe Economy Collection",
      "sort_order": 239,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME8-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME8",
      "fabric_code": "ME8-001",
      "web_name": "Pure Linen",
      "name_key": "pure-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTgtMDAxLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149741859035-ME8-001.jpg",
      "search_text": "ME8-001 Pure Linen Economy Collection",
      "sort_order": 240,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME8-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME8",
      "fabric_code": "ME8-002",
      "web_name": "Warm Porcelain",
      "name_key": "warm-porcelain",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTgtMDAyLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149741859035-ME8-002.jpg",
      "search_text": "ME8-002 Warm Porcelain Economy Collection",
      "sort_order": 241,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME8-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME8",
      "fabric_code": "ME8-003",
      "web_name": "Urban Silver",
      "name_key": "urban-silver",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTgtMDAzLmpwZyIsImVkaXRzIjp7InJlc2l6ZSI6eyJ3aWR0aCI6MjAwLCJmaXQiOiJjb250YWluIn19fQ==",
      "image_filename": "9149741859035-ME8-003.jpg",
      "search_text": "ME8-003 Urban Silver Economy Collection",
      "sort_order": 242,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME15-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME15",
      "fabric_code": "ME15-001",
      "web_name": "Ivory Whisper Show",
      "name_key": "ivory-whisper-show",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTE1LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME15-001.jpg",
      "search_text": "ME15-001 Ivory Whisper Show Economy Collection",
      "sort_order": 243,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME15-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME15",
      "fabric_code": "ME15-002",
      "web_name": "Soft Linen Pearl",
      "name_key": "soft-linen-pearl",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTE1LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME15-002.jpg",
      "search_text": "ME15-002 Soft Linen Pearl Economy Collection",
      "sort_order": 244,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME15-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME15",
      "fabric_code": "ME15-003",
      "web_name": "Silver Haze Song",
      "name_key": "silver-haze-song",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTE1LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME15-003.jpg",
      "search_text": "ME15-003 Silver Haze Song Economy Collection",
      "sort_order": 245,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME15-004",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME15",
      "fabric_code": "ME15-004",
      "web_name": "Urban Ash Leaf",
      "name_key": "urban-ash-leaf",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTE1LTAwNC5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME15-004.jpg",
      "search_text": "ME15-004 Urban Ash Leaf Economy Collection",
      "sort_order": 246,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME16-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME16",
      "fabric_code": "ME16-001",
      "web_name": "Snow Drift Sand",
      "name_key": "snow-drift-sand",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTE2LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME16-001.jpg",
      "search_text": "ME16-001 Snow Drift Sand Economy Collection",
      "sort_order": 247,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME16-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME16",
      "fabric_code": "ME16-002",
      "web_name": "Ivory Mist Ball",
      "name_key": "ivory-mist-ball",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTE2LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME16-002.jpg",
      "search_text": "ME16-002 Ivory Mist Ball Economy Collection",
      "sort_order": 248,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME26-001",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME26",
      "fabric_code": "ME26-001",
      "web_name": "Snowveil",
      "name_key": "snowveil",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTI2LTAwMS5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME26-001.jpg",
      "search_text": "ME26-001 Snowveil Economy Collection",
      "sort_order": 249,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME26-002",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME26",
      "fabric_code": "ME26-002",
      "web_name": "Sandstone Linen",
      "name_key": "sandstone-linen",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTI2LTAwMi5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME26-002.jpg",
      "search_text": "ME26-002 Sandstone Linen Economy Collection",
      "sort_order": 250,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    },
    {
      "id": "roller-semi-blackout-ME26-003",
      "roller_type": "roller",
      "shade_type": "semi-blackout",
      "swatch_product_key": "roller-semi-blackout",
      "tier": "Tier 1",
      "collection_label": "Economy Collection",
      "source_product_label": "Light Filtering Roller Shades - Economy Collection",
      "fabric_series": "ME26",
      "fabric_code": "ME26-003",
      "web_name": "Driftwood Weave Sand",
      "name_key": "driftwood-weave-sand",
      "image_url": "https://d17fzo7x83uajt.cloudfront.net/eyJidWNrZXQiOiJiY3BvIiwia2V5IjoiaDB4c2EyLWF4Lm15c2hvcGlmeS5jb20vOTE0OTc0MTg1OTAzNS1NRTI2LTAwMy5qcGciLCJlZGl0cyI6eyJyZXNpemUiOnsid2lkdGgiOjIwMCwiZml0IjoiY29udGFpbiJ9fX0=",
      "image_filename": "9149741859035-ME26-003.jpg",
      "search_text": "ME26-003 Driftwood Weave Sand Economy Collection",
      "sort_order": 251,
      "available": true,
      "price": 2.0,
      "currency": "USD",
      "match_status": "verified"
    }
  ]
};
